import { useRef, useState } from 'react';
import { apiUpload } from '../api/client';

export function ChatWidget({
  formType,
  enabled,
  onExtract,
  placeholder,
}: {
  formType: string;
  enabled: boolean;
  onExtract: (fields: Record<string, unknown>) => void;
  placeholder?: string;
}) {
  const [message, setMessage] = useState('');
  const [files, setFiles] = useState<File[]>([]);
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [reply, setReply] = useState<string | null>(null);
  const fileRef = useRef<HTMLInputElement>(null);

  if (!enabled) return null;

  const submit = async () => {
    setPending(true);
    setError(null);
    setReply(null);
    try {
      const fd = new FormData();
      fd.append('message', message);
      files.forEach((f) => fd.append('files', f));
      const res = await apiUpload<{ fields: Record<string, unknown>; message: string }>(`/api/assist/${formType}`, fd);
      onExtract(res.fields);
      setReply(res.message);
      setMessage('');
      setFiles([]);
      if (fileRef.current) fileRef.current.value = '';
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setPending(false);
    }
  };

  return (
    <div className="assistant-card">
      <div className="assistant-head">✨ Assistant — describe it or attach a file, and I&apos;ll fill the form</div>
      <textarea
        rows={2}
        value={message}
        placeholder={placeholder ?? 'Describe it in plain English, or attach a business card / PDF / image.'}
        onChange={(e) => setMessage(e.target.value)}
      />
      <div className="assistant-row">
        <input ref={fileRef} type="file" multiple accept=".pdf,image/*,.txt,.csv" onChange={(e) => setFiles(Array.from(e.target.files ?? []))} />
        <button type="button" className="primary" onClick={submit} disabled={pending || (!message.trim() && files.length === 0)}>
          {pending ? 'Reading…' : 'Extract fields'}
        </button>
      </div>
      {reply && <div className="banner ok" style={{ marginTop: '0.75rem' }}>{reply}</div>}
      {error && <div className="banner error" style={{ marginTop: '0.75rem' }}>{error}</div>}
    </div>
  );
}
